export default "__VITE_ASSET__CA0J9q99__"